import * as types from '../mutation-types'

// state
export const state = {
  productIds: [],
}

// getters
export const getters = {
  productIds: (state) => state.productIds || [],
}

// mutations
export const mutations = {
  [types.SET_PRODUCT_IDS](state, { productIds }) {
    state.productIds = productIds
  },
}

// actions
export const actions = {
  setProductIds({ commit }, { productIds }) {
    commit(types.SET_PRODUCT_IDS, { productIds })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}